<template>
  <div class="app-header">
    <div class="app_header_inner">
      <a :href="context">
        <img src="@/assets/images/logo.png" alt />
      </a>
      <!-- <div class="link-box">
        <a href="http://www.zjut.edu.cn/" >
         工大首页
        </a>
        <a href="http://www.cba.zjut.edu.cn/jsp/index.jsp">
        管理学院
        </a>
      </div> -->
      <div class="search-box">
        <input type="text" v-model="searchValue"/>
        <a :href="`${context}/frontend/searchList.html?title=${searchValue}`">
          <i class="iconfont icon-search"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchValue: '',
    };
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/variable.scss';
.app-header {
  background: $theme_color;
  height: $header_height;
  position: relative;
  .app_header_inner {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: $container_width;
    height: 100%;
    line-height: $header_height;
    img {
      vertical-align: middle;
    }
    .link-box{
      position: absolute;
      display: inline-block;
      width: 140px;
      right: 240px;
      box-sizing: border-box;  
      a{
        color:#efefef;
        margin-right:10px;
      }
    }
    .search-box {
      position: absolute;
      display: inline-block;
      width: 200px;
      right: 0;
      box-sizing: border-box;
      input {
        width: 100%;
        padding: 0 20px;
        height: 28px;
        box-sizing: border-box;
        border: none;
        outline: none;
        border-radius: 20px;
        &::placeholder{
          color: #aaa;
        }
      }
      i {
        top: 0;
        right: 5px;
        position: absolute;
        color: #aaa;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue